export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/right-arrow-icon.66f9a9d8.svg","height":32,"width":18};